import React from "react";
import { useTheme } from "@mui/styles";
import Theme from "../../themes/theme";
import { createStyled } from "./utils";
import { Button as ButtonBase, CircularProgress } from "@mui/material";

const getStatus = (value: string, theme: Theme) => {
  let backgroundColor: string = "";
  if (value) {
    value = value.replace(/ /g, "_").toUpperCase();
  }
  switch (value) {
    case "SUCCESS":
    case "ACTIVE":
      backgroundColor = theme.button.contained.background.enabled;
      break;
    case "ENABLED":
      backgroundColor = theme.button.contained.background.enabled;
      break;
    case "DUMMY_ACCOUNT":
      backgroundColor = theme.button.contained.background.enabled;
      break;
    case "SUSPENDED":
      backgroundColor = theme.button.contained.background.suspended;
      break;
    case "RETIRED":
      backgroundColor = theme.button.contained.background.retired;
      break;
    case "PENDING":
      backgroundColor = theme.button.contained.background.pending;
      break;
    case "UNSUCCESS": 
    case "SCHEDULED":
      backgroundColor = theme.button.contained.background.scheduled;
      break;
    case "IN_PROGRESS":
      backgroundColor = theme.button.contained.background.pending;
      break;
    case "PAUSED":
      backgroundColor = theme.palette.UI.navy;
      break;
    case "COMPLETED":
      backgroundColor = theme.button.contained.background.enabled;
      break;
    case "CANCELLED":
      backgroundColor = theme.button.contained.background.cancelled;
      break;
    case "DELIVRD":
    case "DELIVERED":
      backgroundColor = theme.button.contained.background.enabled;
      break;
    case "ALIVE":
    case "INPROGRESS":
      backgroundColor = theme.button.contained.background.pending;
      break;
    case "EXPIRED":
      backgroundColor = theme.button.contained.background.expired;
      break;
    case "DELETED":
      backgroundColor = theme.button.contained.background.retired;
      break;
    case "UNDELIV":
    case "UNDELIVERED":
      backgroundColor = theme.button.contained.background.suspended;
      break;
    case "ACCEPTD":
    case "ACCEPTED":
      backgroundColor = theme.button.contained.background.active;
      break;
    case "ENROUTE":
      backgroundColor = theme.button.contained.background.pending;
      break;
    case "UNKNOWN":
    case "UNKNOWN_STATUS":
      backgroundColor = theme.button.contained.background.retired;
      break;
    case "REJECTD":
    case "REJECTED":
      backgroundColor = theme.button.contained.background.cancelled;
      break;
    case "FAILED": 
      backgroundColor = theme.button.contained.background.failed;
      break;
    case "DROPPED":
      backgroundColor = theme.button.contained.background.dropped;
      break;
    case "COMPLETED_WITH_ERRORS":
      backgroundColor = theme.button.contained.background.partial;
      break;
    default:
      backgroundColor = theme.button.contained.background.primary;
  }
  return backgroundColor;
};

export const Button = ({
  children = null,
  color = null,
  className = null,
  isLoading = false,
  variant = "contained",
  type,
  value = "",
  form,
  size,
  onClick,
  testId,
  startIcon,
  fullWidth,
  disableElevation,
  disabled,
}: {
  children?: JSX.Element | string;
  color?: string;
  className?: any;
  isLoading?: boolean;
  variant?: "contained" | "outlined" | "text";
  value?: string;
  form?: any;
  type?: any;
  size?: any;
  onClick?: (data?: any) => Promise<void> | void;
  testId?: string;
  startIcon?: JSX.Element;
  fullWidth?: boolean;
  disableElevation?: boolean;
  disabled?: boolean;
}) => {
  const theme: Theme = useTheme();
  const Styled = createStyled({
    root: {
      fontWeight: "normal",
    },
    contained: {
      backgroundColor: getStatus(value, theme),
      color: theme.button.contained.color.primary,
      "&:hover": {
        backgroundColor: value
          ? getStatus(value, theme)
          : theme.button.contained.background.hover,
        // color: theme.button.contained.color.hover, //this doesn't exist in theme type
      },
      "&:active": {
        // backgroundColor: theme.button.contained.color.active, //this doesn't exist in theme type
      },
    },
    outlined: {
      border: `1px solid ${theme.button.outlined.color.primary}`,
      backgroundColor: theme.button.outlined.background.primary,
      color: theme.button.outlined.color.primary,
      "&:hover": {
        backgroundColor: theme.button.outlined.background.hover,
        border: `1px solid ${theme.button.outlined.background.hover}`,
        color: theme.button.outlined.color.hover,
      },
      "&:active": {
        // backgroundColor: theme.button.outlined.color.active, //this doesn't exist in theme type
      },
      "&:disabled": {
        backgroundColor: "#E8E8E8",
        color: "#898989",
      },
    },
    select: {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
    },
  });

  return (
    <Styled>
      {({ classes }) => (
        <ButtonBase
          startIcon={startIcon}
          onClick={onClick}
          variant={variant}
          classes={{
            contained: classes.contained,
            root: classes.root,
            outlined: classes.outlined,
          }}
          disabled={disabled}
          form={form}
          type={type}
          size={size}
          fullWidth={fullWidth}
          disableElevation={disableElevation}
          className={className}
          data-testid={testId}
        >
          {isLoading ? (
            <CircularProgress size={22} className={classes.loginLoader} />
          ) : (
            <>{children}</>
          )}
        </ButtonBase>
      )}
    </Styled>
  );
};
